<script>
    /*
	    ReviewEditPanel.svelte

        This basically determines which specific Review panel to display
        (Create, Update, Merge)

        Contains the APPROVE, REJECT and CANCEL buttons
    */

    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { REVIEW_CREATE, REVIEW_UPDATE, REVIEW_MERGE } from '../../common/constants.js';

    // TCARE components
    import ReviewCreatePanel from './ReviewCreatePanel.svelte';
    import ReviewUpdatePanel from './ReviewUpdatePanel.svelte';
    import ReviewMergePanel from './ReviewMergePanel.svelte';


    // SMUI components
    import Button, { Label, Icon } from '@smui/button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftTop, mdiCheck, mdiClose } from '@mdi/js';

    export let review;                          // masterReview object
    export let onApproveReview;                 // implemented on ReviewPage
    export let onRejectReview;                  // implemented on ReviewPage
    export let onCloseReview;                   // implemented on ReviewPage

    onMount(() => {
        // console.log('');
        // console.log('ReviewEditPanel onMount');
        // console.log('review:');
        // console.log(review);
    })

    const approveReview = () => {
        onApproveReview();                      // uses masterReview object
        onCloseReview();
    }

    const rejectReview = () => {
        onRejectReview();                       // uses masterReview object
        onCloseReview();
    }

</script>

<style>
    .review-edit-panel {
        width: 100%;
    }

    .buttons-row {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    :global(.review-edit-panel .mdc-button) {
        /* min-width: 230px !important; */
        border-radius: 18px;
        overflow: hidden;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if review}
    <div class="review-edit-panel">
        <div class="flex-row buttons-row">
            <Button
                color="primary" 
                on:click={() => onCloseReview()} 
                variant="outlined"
                style={'min-width: 230px'}
                >
                <Label>Cancel and Return</Label>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftTop} /></Icon>
            </Button>

            <!-- two icon buttons on right side -->
            <div class="flex-row jc-end">
                <Button 
                    color="primary" 
                    on:click={() => approveReview()} 
                    variant="outlined"
                >
                    <Label>Approve {review.apiData.reviewType}</Label>
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCheck} /></Icon>
                </Button>
                <div class="spacer-w-20"></div>
                <Button
                    color="primary" 
                    on:click={() => rejectReview()} 
                    variant="outlined"
                >
                    <Label>Reject {review.apiData.reviewType}</Label>
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
                </Button>
            </div>

        </div>

        {#if review.apiData.reviewType === REVIEW_CREATE}
            <ReviewCreatePanel {review} />
        {/if}

        {#if review.apiData.reviewType === REVIEW_UPDATE}
            <ReviewUpdatePanel {review} />
        {/if}

        {#if review.apiData.reviewType === REVIEW_MERGE}
            <ReviewMergePanel {review} />
        {/if}

    </div>
{/if}